import React, { useEffect, useRef, useState } from 'react';
import instance from '../../axios';
import Loader from '../../Layout/Loader';
import Table from '../common/tableWithBackEndPagination';
import { Grid, CircularProgress } from '@mui/material';
import TextField from '../common/TextField';
import Button from '../common/Button';
import ConfirmDialoag from '../common/ConfirmDialoag';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { checkPrivileges, errorHandler } from '../../Helpers';


const ArchivedVehiclesTable = ({
  translate,
  themecolors,
  handleCloseArchivedVehicle,
  logInUser
}) => {
  const dispatch=useDispatch()
  const [listVehicles, setListVehicles] = useState({
    data: [],
    page: 1,
    pageSize: 50,
    total: 0,
  });

  const [state,setState]=useState({
    selectedVehicle:"",
    onDataSendConfirmation:false
  })

  const [isApiLoading, setIsApiLoading] = useState(true);
  const [vehicleSearch, setVehicleSearch] = useState('');
  const [showHistoryVehicles, setShowHistoryVehicles] = useState(false);
  const [selectHistoryVehicleId, setSelectHistoryVehicleId] = useState(null);
  const [vehicleHistoryData, setVehicleHistoryData] = useState({
    data: [],
    page: 1,
    pageSize: 10,
    total: 0
  });
  const [vehicleHistoryLoader, setVehicleHistoryLoader] = useState(false);
  const abortControllerRef = useRef(null);


// archivedDeliveryNotes
  const controllerRef = useRef(null);
  const [selectedArchivedVehicleId, setSelectedArchivedVehicleId] = useState(null);
  const [isArchivedNotesModalOpen, setIsArchivedNotesModalOpen] = useState(false);

  const [archivedDeliveryNotes, setArchivedDeliveryNotes] = useState({
    data: [],
    page: 1,
    pageSize: 10,
    total: 0
  });

  const [isLoadingArchivedNotes, setIsLoadingArchivedNotes] = useState(false);
  const [isTriggerApi,setTriggerApi]=useState(false)
  
  useEffect(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const fetchData = async () => {
      try {
        setIsApiLoading(true);
        const response = await instance.get(
          `api/vehicles/get/archived?page=${listVehicles.page}&limit=${listVehicles.pageSize}&search=${vehicleSearch}`,
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            signal: controller.signal,
          }
        );
        setListVehicles((prev) => ({
          ...prev,
          ...response,
        }));
      } catch (error) {
        if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
          console.error('Previous request aborted');
        } else {
          console.error('Fetch failed:', error);
        }
      } finally {
        setIsApiLoading(false);
      }
    };

    fetchData();
    return () => {
      controller.abort();
    };
  }, [listVehicles.page, listVehicles.pageSize,isTriggerApi]);

  const checkFloteNumber = (n) => Number(n) === n && n % 1 !== 0;

  const setPagination = () => {
    const { total = 0, pageSize } = listVehicles;
    const lastPage = total / pageSize;
    return {
      ...listVehicles,
      lastPage: checkFloteNumber(lastPage) ? Math.floor(lastPage) + 1 : lastPage,
    };
  };

  const handleChangeRowsPerPage = (rowPerPage) => {
    setListVehicles((prev) => ({
      ...prev,
      page: 1,
      pageSize: rowPerPage,
    }));
  };

  const handleChangePage = (value) => {
    setListVehicles((prev) => ({
      ...prev,
      page: value,
    }));
  };

  const handleSearchVehicle = (e) => {
    setVehicleSearch(e.target.value);

  };
  const handleSearchBtn=()=>{
    setListVehicles((prev) => ({
      ...prev,
      page: 1,
    }));

    setTriggerApi((prev)=>!prev)
  }

  const getVehicleHistoryData = async (id) => {
    setVehicleHistoryLoader(true);
    try {
      const response = await instance.get(
        `/api/vehicles/get/ownershiplogs?vehicleId=${id}&page=${vehicleHistoryData.page || 1}&limit=${vehicleHistoryData?.pageSize || 10}`,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      setVehicleHistoryData((prevState) => ({
        ...prevState,
        ...response
      }));
    } catch (error) {
      console.error('Error fetching vehicle history:', error);
    } finally {
      setVehicleHistoryLoader(false);
    }
  };

  const handleOpenShowVehicleHistory = (value) => {
    if (value?.[0]) {
      setSelectHistoryVehicleId(value[0]?.id);
      setShowHistoryVehicles(true);
    }
  };

  const handleCancelShowVehicleHistory = () => {
    setShowHistoryVehicles(false);
    setSelectHistoryVehicleId(null);
    setVehicleHistoryData((prevState) => ({
      ...prevState,
      data: [],
      page: 1,
      pageSize: 10,
      total: 0
    }))
  };

  const handleChangePageVehicleHistory = (value) => {
    setVehicleHistoryData((prevState) => ({
      ...prevState,
      page: value
    }))
  };

  const handleChangePerPageVehicleHistory = (rowPerPage) => {
    setVehicleHistoryData((prevState) => ({
      ...prevState,
      pageSize: rowPerPage,
      page: 1
    }))
  };

  useEffect(() => {
    if (selectHistoryVehicleId) {
      getVehicleHistoryData(selectHistoryVehicleId);
    }
  }, [vehicleHistoryData?.page, vehicleHistoryData?.pageSize, selectHistoryVehicleId])

  const setPaginationVehicleHistory = () => {
    const lastPage = vehicleHistoryData?.total / vehicleHistoryData?.pageSize;
    return {
      page: vehicleHistoryData?.page,
      pageSize: vehicleHistoryData?.pageSize,
      total: vehicleHistoryData?.total,
      lastPage: checkFloteNumber(lastPage) ? Math.floor(lastPage) + 1 : lastPage,
    };
  };

  // archivedVehicleDns
  const fetchArchivedDeliveryNotes = async (vehicleId) => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
  
    controllerRef.current = new AbortController();
  
    setIsLoadingArchivedNotes(true);
    try {
      const response = await instance.get(
        `/api/deliverynotes/get`,
        {
          params: {
            page: archivedDeliveryNotes.page,
            limit: archivedDeliveryNotes.pageSize,
            plateNumber:vehicleId
          },
          signal: controllerRef.current.signal
        }
      );
      setArchivedDeliveryNotes((prev) => ({
        ...prev,
        ...response
      }));
    } catch (error) {
      if (error.name === 'CanceledError') {
        console.log('Request canceled');
      } else {
        console.error('Error fetching archived delivery notes:', error);
      }
    } finally {
      setIsLoadingArchivedNotes(false);
    }
  };
  

  const handleArchivedVehicleRowClick = (rows) => {
    const vehicleId = rows?.[0]?.vehicleLicensePlate;
    if (vehicleId) {
      setSelectedArchivedVehicleId(vehicleId);
      setIsArchivedNotesModalOpen(true);
    }
  };

  const handleCloseArchivedNotesModal = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
  
    setIsArchivedNotesModalOpen(false);
    setSelectedArchivedVehicleId(null);
    setArchivedDeliveryNotes({
      data: [],
      page: 1,
      pageSize: 10,
      total: 0
    });
  };
  

  const handleArchivedNotesPageChange = (newPage) => {
    setArchivedDeliveryNotes((prev) => ({
      ...prev,
      page: newPage
    }));
  };

  const handleArchivedNotesPageSizeChange = (newPageSize) => {
    setArchivedDeliveryNotes((prev) => ({
      ...prev,
      pageSize: newPageSize,
      page: 1
    }));
  };

  useEffect(() => {
    if (selectedArchivedVehicleId && isArchivedNotesModalOpen) {
      fetchArchivedDeliveryNotes(selectedArchivedVehicleId);
    }
  }, [
    archivedDeliveryNotes.page,
    archivedDeliveryNotes.pageSize,
    selectedArchivedVehicleId,
    isArchivedNotesModalOpen
  ]);
  const setPaginationArchivedDeliveryNotes = () => {
    const lastPage = archivedDeliveryNotes?.total / archivedDeliveryNotes?.pageSize;
    return {
      page: archivedDeliveryNotes?.page,
      pageSize: archivedDeliveryNotes?.pageSize,
      total: archivedDeliveryNotes?.total,
      lastPage: checkFloteNumber(lastPage) ? Math.floor(lastPage) + 1 : lastPage,
    };
  };
  const onVehicleSendData=()=>{
      if (state.selectedVehicle && state.selectedVehicle?.id) {
      instance({
        url: `/api/vehicles/integrationwithid/${state.selectedVehicle?.id}`,
        method: 'GET',
      })
      .then((response) => {
          toast.success( translate(response));
          setState((prevState)=>({
            ...prevState,
            selectedVehicle:"",
            onDataSendConfirmation:false
          }))
         setTriggerApi((prev)=>!prev)

 
      }).catch(error => {
        errorHandler(error,dispatch)
                  setState((prevState)=>({
            ...prevState,
            selectedVehicle:"",
            onDataSendConfirmation:false
          }))
      }
        
      )
    }

  }

    const sendDataEnable = (selected) => {
    if (selected[0]) {
      setState((prevState)=>({
        ...prevState,
          selectedVehicle: selected[0],
        onDataSendConfirmation: true,
      }))
    } else {
            setState((prevState)=>({
        ...prevState,
          selectedVehicle: selected[0],
        onDataSendConfirmation: true,
      }))
    }
  };

    const onVehicleSendDataCancel=()=>{
                  setState((prevState)=>({
        ...prevState,
        onDataSendConfirmation: false,
      }))
  }
  return (
    <div>
      <Grid container className="breadcrumb-row" style={{ paddingLeft: 10, paddingRight: 10 }}>
        <Grid item xs={12} sm={3}>
          <h3 style={{ margin: 0 }}>{translate('archivedVehicles')}</h3>
        </Grid>
        <Grid item xs={12} sm={9} style={{ justifyContent: 'flex-end' }}>
          <div style={{ width: '25%', marginRight: 20 }}>
            <TextField
              fullWidth
              label={translate('search')}
              value={vehicleSearch}
              onChange={handleSearchVehicle}
            />
          </div>
                 <Button
            aria-label="searchVehicle"
            size="small"
            color="inherit"
            onClick={handleSearchBtn}
            id="searchVehicle"
          >
            {translate('search')}
          </Button>
          <Button
          style={{marginLeft:"0.5rem"}}
            aria-label="modelSearch"
            size="small"
            color="inherit"
            onClick={handleCloseArchivedVehicle}
            id="modelSearch"
          >
            {translate('back')}
          </Button>
        </Grid>
      </Grid>

      {isApiLoading ? (
        <Loader />
      ) : (
        <Table
          rows={listVehicles.data}
          pagination={setPagination()}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          translate={translate}
          handleChangePage={handleChangePage}
          isEditable={true}
          canUpdate
          isCursoPointer
          isShowVehiclHistory
          archiveTable
          isVehicleTable
          isShowVehicleStatus
          handleArchivedVehicleHistory={handleArchivedVehicleRowClick}
          handleOpenShowVehicleHistory={handleOpenShowVehicleHistory}
          hasAccessOfDelete={false}
          hasAccessOfUpdate={true}
          themecolors={themecolors}
          hasAccessOfVehicleSendData={checkPrivileges("vehicleIntegrateSingle")}
          onVehicleSendData={sendDataEnable}
          rowDefinition={[
            { id: 'label', label: translate('label') },
            { id: 'category', label: translate('vehicleType') },
            { id: 'vehicleLicensePlate', label: translate('vehicleLicensePlate') },
            { id: 'attributes.parentName', label: translate('account') },
            { id: 'attributes.contractNumber', label: translate('contractNumber') },
            { id: 'make', label: translate('make') },
            { id: 'purchaseDate', label: translate('purchaseDate') },
            { id: 'year', label: translate('year') },
            { id: 'vin', label: translate('vin') },
            { id: 'deliveryDate', label: translate('deliveryDate') },
            { id: 'attributes.depreciationCost', label: translate('depreciationCost') },
            { id: 'created', label: translate('created') },
            { id: 'archiveTime', label: translate('archiveTime') },

          ]}
        />
      )}

      {showHistoryVehicles && (
        <ConfirmDialoag
          onCancel={handleCancelShowVehicleHistory}
          onOk={handleCancelShowVehicleHistory}
          title={translate('archivedVehicleHistory')}
          maxWidth={"lg"}
        >
          <div>
            {vehicleHistoryLoader ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                }}
              >
                <CircularProgress color="success" />
              </div>
            ) : vehicleHistoryData?.data?.length > 0 ? (
              <Table
                rows={vehicleHistoryData?.data || []}
                pagination={setPaginationVehicleHistory()}
                handleChangePage={handleChangePageVehicleHistory}
                handleChangeRowsPerPage={handleChangePerPageVehicleHistory}
                translate={translate}
                rowsPerPage={vehicleHistoryData?.pageSize}
                themecolors={themecolors}
                vehicleHistoryTable
                rowDefinition={[
                  {
                    id: 'attributes.userName',
                    numeric: false,
                    disablePadding: false,
                    label: translate('userName'),
                  },
                  {
                    id: 'oldContractNumber',
                    numeric: false,
                    disablePadding: false,
                    label: translate('contractNumber'),
                  },
                  {
                    id: 'created',
                    numeric: false,
                    disablePadding: false,
                    label: translate('createdDate'),
                  },
                ]}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 500,
                  color:"gray",
                }}
              >
                {translate('nodataFound')}
              </div>
            )}
          </div>
        </ConfirmDialoag>
      )}
      {isArchivedNotesModalOpen && (
        <ConfirmDialoag
          onCancel={handleCloseArchivedNotesModal}
          onOk={handleCloseArchivedNotesModal}
          title={translate('archivedVehicleDeliveryNotes')}
          maxWidth={"lg"}
        >
          <div>
            {isLoadingArchivedNotes ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                }}
              >
                <CircularProgress color="success" />
              </div>
            ) : archivedDeliveryNotes?.data?.length > 0 ? (
              <Table
                rows={archivedDeliveryNotes?.data || []}
                pagination={setPaginationArchivedDeliveryNotes()}
                handleChangePage={handleArchivedNotesPageChange}
                handleChangeRowsPerPage={handleArchivedNotesPageSizeChange}
                translate={translate}
                timezone={logInUser?.attributes?.timezone || 'Asia/Riyadh'}
                rowsPerPage={archivedDeliveryNotes?.pageSize}
                themecolors={themecolors}
                vehicleHistoryTable
                rowDefinition={[
                  {
                    id: 'deliveryNoteNumber',
                    numeric: false,
                    disablePadding: false,
                    label: translate('deliveryNoteNumber'),
                  },
                  {
                    id: 'deliveryNoteRefNumber',
                    numeric: false,
                    disablePadding: false,
                    label: translate('deliveryNoteRefNumber'),
                  },
                  {
                    id: 'created',
                    numeric: false,
                    disablePadding: false,
                    label: translate('created'),
                  },

                  {
                    id: 'saleNetAmount',
                    numeric: false,
                    disablePadding: false,
                    label: translate("Total Amount"),
                  },
                  {
                    id: 'viewArchivedDns',
                    numeric: false,
                    disablePadding: false,
                    label: translate("View"),
                  },
                ]}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color:"gray",
                  fontWeight: 500,
                }}
              >
                {translate('nodataFound')}
              </div>
            )}
          </div>
        </ConfirmDialoag>
      )}
      {state.onDataSendConfirmation && (
                <>
                  <ConfirmDialoag
                    onCancel={onVehicleSendDataCancel}
                    onOk={onVehicleSendData}
                    title={translate("Are You Want To Sync With Servers")}
                    children={state.selectedVehicle.label}
                  />
                </>
              )}
    </div>
  );
};

export default ArchivedVehiclesTable;
